var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.buttonTextColor,attrs:{"color":_vm.buttonColor},on:{"click":_vm.toggleMusicVolume}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("volume_down")]),_vm._v(" "+_vm._s(_vm.dropVolume ? 'End Announcement' : 'Announce')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }